import get from 'lodash.get';
// import brandKeysJSON from './brandKeys.json';

const hasSectionBySlug = (
  slugString,
  article,
) => (get(article, 'taxonomy.sections') || []).some(
  (section) => section.slug === slugString,
);

const hasChannelBySlug = (
  slugString,
  article,
) => (get(article, 'taxonomy.channels') || []).some(
  (channel) => channel.slug === slugString,
) || (get(article, 'taxonomy.primarySection.slug') === slugString);

const isTheTopic = (
  topicId,
  article,
) => (get(article, 'taxonomy.topics') || []).some(
  (topic) => topic.id.toLowerCase() === topicId.toLowerCase(),
);

// eslint-disable-next-line consistent-return
const getRealNewsletterName = (vertical, article) => {
  switch (vertical) {
    case 'news':
      if (hasChannelBySlug('the-thread', article)) {
        return 'byers_brief';
      }
      break;
    case 'today':
      if (hasSectionBySlug('style', article)) {
        return 'style';
      }
      if (hasSectionBySlug('shop', article)) {
        return 'shop';
      }
      break;
    case 'dateline':
      return 'dateline';
    default:
      return 'news';
  }
};

const title = (vertical, article) => {
  if (!['today', 'news', 'noticias'].includes(vertical)) {
    return null;
  }

  let titleString = '';

  switch (vertical) {
    case 'today':
      if (
        hasSectionBySlug('style', article)
        || hasSectionBySlug('shop', article)
      ) {
        titleString = 'Stuff We Love';
      }
      break;
    case 'news':
      if (
        hasChannelBySlug('the-thread', article)
        || hasChannelBySlug('tech', article)
      ) {
        titleString = 'Byers Market Newsletter';
      }

      if (
        isTheTopic('nctx18276', article)
        || isTheTopic('nctx17706', article)
        || isTheTopic('nctx53', article)
        || isTheTopic('nctx19211', article)
        || isTheTopic('nctx19186', article)
      ) {
        titleString = 'The Morning Rundown';
      }
      break;
    case 'noticias':
      titleString = 'Suscríbete al Email de Noticias Telemundo';
      break;
    default:
      break;
  }


  return titleString;
};

const description = (vertical, article) => {
  switch (vertical) {
    case 'news':
      // Byers Market Newsletter
      if (
        hasSectionBySlug('the-thread', article)
        || hasSectionBySlug('tech', article)
      ) {
        return 'Get breaking news and insider analysis on the rapidly changing world of media and technology right to your inbox.';
      }
      // morning rundown
      if (
        isTheTopic('nctx18276', article)
        || isTheTopic('nctx17706', article)
        || isTheTopic('nctx53', article)
        || isTheTopic('nctx19211', article)
      ) {
        return `Get a head start on the morning's top stories.`; // eslint-disable-line
      }
      return 'Let our news meet your inbox. The news and stories that matters, delivered weekday mornings.';
    case 'today':
      if (
        hasSectionBySlug('shop', article)
        || hasSectionBySlug('style', article)
      ) {
        return 'Get a daily roundup of items that will make your life easier, healthier and more stylish.';
      }
      return 'Trending stories,celebrity news and all the best of TODAY.';
    case 'globalcitizen':
      return 'Get the MSNBC Daily newsletter.';
    case 'dateline':
      return '';
    case 'noticias':
      return 'Todos los días, las últimas noticias directamente en tu correo electrónico';
    default:
      return `Get the ${vertical} newsletter.`;
  }
};

// Not currently used
// const pickBrandKey = (article) => {
//   const brand = get(article, 'taxonomy.primaryVertical.slug') || 'news';
//   const keyset = process.env.NODE_ENV === 'production'
//     ? brandKeysJSON[brand].p.key
//     : brandKeysJSON[brand].d.key;
//   return keyset;
// };

export const pickSiteKey = (vertical) => {
  switch (vertical) {
    case 'news':
      return '6LfB-pUUAAAAACholya1Laf2TuFO8pyhvTcnoG0A';
    case 'today':
      return '6LfB-pUUAAAAACholya1Laf2TuFO8pyhvTcnoG0A';
    case 'msnbc':
      return '6LfB-pUUAAAAACholya1Laf2TuFO8pyhvTcnoG0A';
    case 'noticias':
      return '6LfHVOQUAAAAAPSCmupFMjHMATCo3lMVB9f6LFdK';
    default:
      return '6LfB-pUUAAAAACholya1Laf2TuFO8pyhvTcnoG0A'; // news
  }
};

export default function verticalLogic(vertical, article) {
  const theTitle = title(vertical, article);
  const listName = getRealNewsletterName(vertical, article);

  return {
    title: theTitle,
    description: description(vertical, article),
    newsletterId: listName,
    newsletterIdVars: `sub_${listName}`,
    listvar: `vars[${listName}]`,
    listOptinTimeStamp: new Date().getTime(),
    openPub: theTitle,
    stKey: pickSiteKey(vertical),
  };
}
